export default () => ({
  isLoading: false,
  isLoaded: false,
  error: null,

  declaration: null
})
